import React from "react";
import TopBar from "../topbar/TopBar";
import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Gate from "../../../src/assets/svg/gate_master.svg";
import Vehicle from "../../../src/assets/svg/VehicleTYpe_ic_sel.svg";
import Purpose from "../../../src/assets/svg/purpose.svg";
import Check from "../../../src/assets/svg/checks.svg";
import Watssapp from "../../../src/assets/svg/watssapp.svg";
import Template from "../../../src/assets/svg/Tempalte_ic.svg";
import Alert from "../../../src/assets/svg/alert.svg";
import Register from "../../../src/assets/svg/register.svg";
import NfcInactive from "../../../src/assets/svg/nfc_inactive.svg";
import arrow from "../../assets/svg/backarrow.svg";
import GateSel from "../../../src/assets/svg/gate_mast_sel.svg";
import VehicleSel from "../../../src/assets/svg/vehicle_sel.svg";
import PurposeSel from "../../../src/assets/svg/purpose_of_sel.svg";
import CheckSel from "../../../src/assets/svg/checkList_selec_ic.svg";
import WatssappSel from "../../../src/assets/svg/whatsapp_sel.svg";
import TemplateSel from "../../../src/assets/svg/template_sel.svg";
import AlertSel from "../../../src/assets/svg/alet_sel.svg";
import RegisterSel from "../../../src/assets/svg/register_sel.svg";
import NfcActive from "../../../src/assets/svg/nfc_active.svg";

import { useTab } from "../common/context/tabcontext";
import { useGlobal } from "../../GlobalContext.js";

const Sidebar = ({ activeMenu }) => {
  const navigate = useNavigate();
  const [active, setActive] = useState(0);
  const { activeMaster, setActiveMaster } = useTab();
  const [hoverMaster, setHoverMaster] = useState("");
  const { rolePermissionList, userType } = useGlobal();

  const menuItems = [
    { label: "Gate Masters", icon: Gate, iconSel: GateSel, route: "/gatemasters" },
    { label: "Vehicle Types", icon: Vehicle, iconSel: VehicleSel, route: "/vehiclemasters" },
    { label: "Purpose of Visit", icon: Purpose, iconSel: PurposeSel, route: "/purposeofvisit" },
    { label: "Check List", icon: Check, iconSel: CheckSel, route: "/checklist" },
    { label: "Business Partners", icon: Alert, iconSel: AlertSel, route: "/customers" },
    { label: "Product Type", icon: Gate, iconSel: GateSel, route: "/products" },
    { label: "WhatsApp Template", icon: Watssapp, iconSel: WatssappSel, route: "/whatsapptemplate" },
    { label: "Template", icon: Template, iconSel: TemplateSel, route: "/template" },
    { label: "Alert Configuration", icon: Alert, iconSel: AlertSel, route: "/alertconfiguration" },
    { label: "Register Fields", icon: Register, iconSel: RegisterSel, route: "/registerfields" },
    // { label: "NFC", icon: NfcInactive, iconSel: NfcActive, route: "/nfc" },
  ];

  function checkPermission(menuName, permission) {
    if (menuName === "Gate Masters" || menuName === "Template" || menuName === "Alert Configuration" || menuName === "Register Fields") {
      return rolePermissionList.findIndex((element) => element["name"] === "Gate - Setup" && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
    } else if (menuName === "Vehicle Types") {
      return rolePermissionList.findIndex((element) => element["name"] === "Vehicletype - Setup" && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
    } else if (menuName === "Purpose of Visit") {
      return rolePermissionList.findIndex((element) => element["name"] === "Purpose of visit - Setup" && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
    } else if (menuName === "Check List") {
      return rolePermissionList.findIndex((element) => element["name"] === "Checklist - Setup" && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
    } else if (menuName === "WhatsApp Template") {
      return rolePermissionList.findIndex((element) => element["name"] === "Gate - Setup" && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
    }
  }

  return (
    <div
      style={{
        paddingTop: "16px",
        paddingBottom: "16px",
        borderRight: "0.5px solid #E5E5E5",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        backgroundColor: "#FFFFFF",
        fontFamily: "Epilogue",
        height: "100%",
        width: "16.67vw",
      }}>
      <div
        style={{
          display: "flex",
          padding: "14px",
          alignItems: "center",
          gap: "12px",
        }}>
        <div
          style={{ width: "40px", height: "40px", cursor: "pointer" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            navigate("/dashboard");
          }}
        >
          <img src={arrow} alt="Back to Dashboard" style={{ width: "40px", height: "40px" }} />
        </div>

        <div style={{ fontWeight: "700", fontSize: "20px", color: "#172B4D" }}>Admin Setup</div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {menuItems.map((item, index) => {
          const isActive = activeMaster === index;
          // if (checkPermission(item.label, "menu_permission"))
          return (
            <Link key={index} to={item.route} onClick={() => setActiveMaster(index)} style={{ textDecoration: "none" }}>
              <div
                onMouseEnter={() => setHoverMaster(item.label)}
                onMouseLeave={() => setHoverMaster("")}
                style={{
                  borderRadius: activeMenu === item.label ? "4px 100px 100px 4px" : hoverMaster === item.label ? "4px 100px 100px 4px" : "4px",
                  backgroundColor: activeMenu === item.label ? "#D5FFE6" : hoverMaster === item.label ? "#F5F7F9" : "transparent",
                  padding: "10px 10px 10px 20px",
                  display: "flex",
                  gap: "12px",
                  alignItems: "center",
                  transition: "0.2s",
                }}>
                <div>
                  <img style={{ width: "20px", color: activeMenu === item.label ? "#2C8C53" : null }} src={activeMenu === item.label ? item.iconSel : item.icon} alt={item.label} />
                </div>
                <div
                  style={{
                    fontWeight: activeMenu === item.label ? "600" : "500",
                    fontSize: "13px",
                    color: activeMenu === item.label ? "#2C8C53" : "#172B4D",
                  }}>
                  {item.label}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;
